var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21075_13878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1 27.1658L25.3166 5.96583C24.7997 5.15719 24.0875 4.4917 23.2458 4.03073C22.404 3.56975 21.4597 3.32813 20.5 3.32812C19.5402 3.32813 18.5959 3.56975 17.7542 4.03073C16.9124 4.4917 16.2002 5.15719 15.6833 5.96583L2.89996 27.1658C2.44839 27.9186 2.20294 28.777 2.18832 29.6547C2.17369 30.5324 2.39039 31.3984 2.81663 32.1658C3.30943 33.0296 4.02273 33.7471 4.88363 34.2449C5.74454 34.7427 6.72217 35.003 7.71663 34.9992H33.2833C34.2712 35.0097 35.2444 34.7595 36.1048 34.2737C36.9651 33.788 37.682 33.0839 38.1833 32.2325C38.6221 31.4571 38.8457 30.5786 38.831 29.6878C38.8164 28.797 38.564 27.9264 38.1 27.1658ZM35.2666 30.5825C35.0663 30.9268 34.7756 31.2098 34.426 31.4007C34.0764 31.5917 33.6813 31.6834 33.2833 31.6658H7.71663C7.31867 31.6834 6.92349 31.5917 6.57389 31.4007C6.2243 31.2098 5.93361 30.9268 5.7333 30.5825C5.58702 30.3291 5.51001 30.0417 5.51001 29.7492C5.51001 29.4566 5.58702 29.1692 5.7333 28.9158L18.5333 7.69916C18.7633 7.39534 19.0606 7.14894 19.4018 6.97929C19.743 6.80963 20.1189 6.72135 20.5 6.72135C20.881 6.72135 21.2569 6.80963 21.5981 6.97929C21.9394 7.14894 22.2366 7.39534 22.4666 7.69916L35.25 28.8992C35.4019 29.153 35.4835 29.4427 35.4864 29.7386C35.4894 30.0344 35.4135 30.3257 35.2666 30.5825Z",
    fill: "#FF2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 28.3333C21.4205 28.3333 22.1667 27.5871 22.1667 26.6667C22.1667 25.7462 21.4205 25 20.5 25C19.5796 25 18.8334 25.7462 18.8334 26.6667C18.8334 27.5871 19.5796 28.3333 20.5 28.3333Z",
    fill: "#FF2828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13.334C20.058 13.334 19.6341 13.5096 19.3215 13.8221C19.009 14.1347 18.8334 14.5586 18.8334 15.0007V21.6673C18.8334 22.1093 19.009 22.5333 19.3215 22.8458C19.6341 23.1584 20.058 23.334 20.5 23.334C20.9421 23.334 21.366 23.1584 21.6786 22.8458C21.9911 22.5333 22.1667 22.1093 22.1667 21.6673V15.0007C22.1667 14.5586 21.9911 14.1347 21.6786 13.8221C21.366 13.5096 20.9421 13.334 20.5 13.334Z",
    fill: "#FF2828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21075_13878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.e02c68e4cb1919b9c1f540c0e140ce23.svg";